

import img1 from '../images/slider/slider-product-1.jpg'
import img2 from '../images/slider/slider-product-2.jpg'
import img3 from '../images/slider/slider-product-3.jpg'
import img4 from '../images/slider/slider-product-4.jpg'
import img5 from '../images/slider/slider-product-5.jpg'

const dataBanner2 = [
    {
        id: 1,
        heading: 'Discover, Store and Redeem Top Brand Vouchers',
        desc: 'Your secure vault for brand vouchers. Buy from top brands. Store safely. Redeem anytime you want.',
        img: img1,
    },
    {
        id: 2,
        heading: 'Shop Smart, Save More with Digital Vouchers',
        desc: 'Get instant access to exclusive deals from Amazon, Flipkart, Netflix, and 100+ premium brands.',
        img: img2,
    },
    {
        id: 3,
        heading: 'Your Digital Wallet for Gift Cards & E-Vouchers',
        desc: 'Purchase, manage, and redeem all your vouchers in one secure place. No more lost gift cards!',
        img: img3,
    },
    {
        id: 4,
        heading: 'Instant Delivery, Lifetime Access to Your Vouchers',
        desc: 'Receive vouchers instantly after payment. Access them anytime from your personal dashboard.',
        img: img4,
    },
    {
        id: 5,
        heading: 'Trusted by Thousands for Secure Voucher Management',
        desc: 'Join India\'s leading digital voucher marketplace. Safe transactions, verified brands, 24/7 support.',
        img: img5,
    },
]

export default dataBanner2;